import { Box, SimpleGrid, Text } from "@chakra-ui/react";
import React, { useEffect } from "react";
import Note from "./Note";

const LIST_SIZE = 24;

interface INote {
  id: string;
  title: string;
  items: { text: string; link?: string; comment: string; visited: boolean }[];
  tags: string[];
}

interface NoteListProps {
  notes: INote[];
}

const NoteList: React.FC<NoteListProps> = ({ notes }) => {
  const displayedNotes = notes.slice(0, LIST_SIZE);
  const hasMoreNotes = notes.length > LIST_SIZE;

  useEffect(() => {
    // This effect runs once when the component mounts
    const hash = window.location.hash;
    if (hash) {
      // Use a timeout to ensure all notes are rendered before scrolling
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "center" });
          
          // Optional: Add a temporary class for highlighting
          element.classList.add("highlighted-note");
          // setTimeout(() => {
          //   element.classList.remove("highlighted-note");
          // }, 30000); // Highlight for 2.5 seconds
        }
      }, 100);
    }
  }, []); // Empty dependency array ensures this runs only once on mount

  return (
    <Box className="note-list" maxWidth="80vw" mx="auto" p={4}>
      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4}>
        {displayedNotes.map((note, index) => (
          // Use the note ID to set a unique HTML id for the wrapper Box
          <Box key={note.id} id={`note-${note.id}`}>
            <Note
              id={note.id} // Pass the ID to the Note component for the share button
              title={note.title}
              items={note.items}
              tags={note.tags}
            />
          </Box>
        ))}
      </SimpleGrid>
      {hasMoreNotes && (
        <Box textAlign="center" mt={4}>
          <Text fontSize="xl" color="gray.500">
            ...
          </Text>
        </Box>
      )}
    </Box>
  );
};

export default NoteList;